<div class="dc-modal verify-email-modal">
  <div class="dc-modal-container max-w-[500px]!">
    <button class="modal-x-button" type="button" (click)="closeModal()">
      <i class="fas fa-close"></i>
    </button>
    <div class="text-center">
      <h1 class="text-xl font-semibold text-dc-navy! mb-2">
        {{ "MFA_VERIFY.TITLE" | translate }}
      </h1>

      <div class="modal-body-content text-center pt-3">
        <p class="!text-sm text-dc-navy! text-left">
          {{ "MFA_VERIFY.SUBTITLE" | translate }}
          @if (maskedEmail) {
            <span>({{ maskedEmail }})</span>
          }
        </p>

        <div class="field-control mt-4 text-left">
          <app-text-field
            [label]="''"
            [hideLabel]="true"
            [placeholder]="'VERIFY.OTP_PLACEHOLDER' | translate"
            [control]="otpForm.get('otp')!"
            [maxlength]="6"
          />

          @if (errorMessage) {
            <div class="fields-error-container text-left mt-1">
              {{ errorMessage | translate }}
            </div>
          }

          @if (countdownSecondsRemaining > 0) {
            <p class="mt-2 text-sm text-dc-navy text-left">
              {{ "VERIFY.RESEND_IN" | translate: { time: formattedCountdown } }}
            </p>
          }
        </div>

        <div class="flex gap-3 justify-center">
          @if (!loading) {
            <app-button
              type="button"
              classesName="verify-pill-btn w-full"
              [label]="'MFA_VERIFY.CONTINUE' | translate"
              (onBtnClick)="verifyOtp()"
            ></app-button>

            <div [class.opacity-60]="!canResendOtp" [class.pointer-events-none]="!canResendOtp">
              <app-button
                type="button"
                classesName="card-edge-cut-white"
                [label]="'MFA_VERIFY.RESEND_CODE' | translate"
                (onBtnClick)="resendOtp()"
              ></app-button>
            </div>
          } @else {
            <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
          }
        </div>
      </div>
    </div>
  </div>
</div>
